import React from 'react';
import PostIcons from '../PostIcons';
import PostIconsTitle from '../PostIconsTitle';
import PostRate from '../PostRate';
import PostLabelIcon from '../PostLabelIcon';
import CategoryItems from '../CategoryItems';
import PostButton from '../PostButton';
import PostGallery from '../PostGallery';
import ArrowRight from '../../assets/images/icons/ArrowRight.svgr'; 

function post(props) {
  const {
    post,
    postType,
    displayAuthor,
    displayExcerpt,
    displayDate,
    displayCategories,
    currentPage,
    replaceSelected, 
    theExcerpt
  } = props;

  let categories;
  let categoryItems;
  let author;
  let excerpt;
  let date;
  let postLabelIcon;
  let postRate;
  let postIconsTitle;
  let postIcons;
  let postButton;
  let postGallery;
  let postLink;

  postLink = post.link;
  if ( currentPage > 1 ) {
    postLink = `${post.link}?backpage=${currentPage}`;
  }

  if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:term')) {
    categories = post._embedded['wp:term'][0];
  }

  if (categories && displayCategories) {
      categoryItems = <CategoryItems
      items = {categories}
    ></CategoryItems>
  }

  if (post.author && displayAuthor) {
    author = <span className="author">By {post.author}</span>
  }

  if (post.excerpt && displayExcerpt) {
    excerpt = <div className="eight29-post-excerpt" dangerouslySetInnerHTML={{__html: post.excerpt.rendered}}>
    </div>
  }

  if (displayDate) {
    date = <time>{post.formatted_date}</time>
  }

  if (post.acf_cabins_label || post.acf_cabins_label_icon) {
      postLabelIcon = <PostLabelIcon
      label = {post.acf_cabins_label}
      icon = {post.acf_cabins_label_icon}
    ></PostLabelIcon>
  }

  if (post.acf_cabins_rates) {
      postRate = <PostRate
      rate = {post.acf_cabins_rates}
    ></PostRate>
  }

  if (post.acf_cabins_icons_title) {
      postIconsTitle = <PostIconsTitle
      icons = {post.acf_cabins_icons_title}
    ></PostIconsTitle>
  }

  if (post.acf_cabins_icons) {
      postIcons = <PostIcons
      icons = {post.acf_cabins_icons}
    ></PostIcons>
  }

  if (post.acf_cabins_button) {
    const title = post.acf_cabins_button.title.length > 0 ? post.acf_cabins_button.title : 'View Availability'
    postButton = <button 
      className="c-btn c-btn-primary flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-84 fb-entity-config-id- fb-domain-go.theflybook.com fb-protocol-https">
      <span>{title}</span>
    </button>
  }

  if (post.acf_cabins_gallery) {
    postGallery = <div className="cpt-post-gallery">
      <div className="cpt-post-gallery-wrapper">
        <PostGallery
          post = {post}
          gallery = {post.acf_cabins_gallery}
          imageSize = 'hero-gallery-1'
        ></PostGallery>
      </div>
    </div>
  }

  return (
    <article id={`${postType}-${post.id}`} className="eight29-post eight29-post-card cpt-post">
      <div className="cpt-post-wrapper">
        <div className="cpt-post-left">
          {postLabelIcon}
          {postGallery}
        </div>
        <div className="cpt-post-right">
          <div className="eight29-post-body">
            <div className="cpt-post-right-header">
              <div className="cpt-post-right-header-category">
              {categoryItems}
              </div>
              {postLabelIcon}
            </div>
            <div className="eight29-post-detail">
              <div className="cpt-post-detail">
                <div className="cpt-post-detail-left">
                  <h3 className="eight29-post-title"><a className="cpt-post-link" href={postLink} dangerouslySetInnerHTML={{__html: post.title.rendered}}></a></h3>

                  {postRate}
                  {postIcons}
                  {excerpt}
                  {postIconsTitle}
                  {date}
                  {author}
                </div>
                <div className="cpt-post-detail-right">
                  {postIcons}
                </div>
              </div>
              <div className="cpt-post-buttons">
                <a href={postLink} className="c-btn c-btn-tertiary">
                  Learn more
                  <span className="c-btn-icon">
                    <ArrowRight></ArrowRight>
                  </span>
                </a>
              </div>
            </div>
            {postButton}
          </div>
        </div>
      </div>
    </article>
  );
}

export default post;